/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Model_Update_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update default model. Please try again." |
*
* @param {Preferences_Model_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_model_update_error = /** @type {((inputs?: Preferences_Model_Update_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Model_Update_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Aktualisieren des Standardmodells. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update default model. Please try again.")
});